export const selectLoadingUser = (store) => store.user.loading;
export const selectUser = (store) => store.user.user;
export const selectEmailIsSend = (store) => store.user.emailIsSend;
export const selectLoginSuccess = (store) => store.user.loginSuccess;
export const selectErrorsEmail = (store) => store.user.errors.email;
export const selectErrorsLogin = (store) => store.user.errors.login;
export const selectToken = (store) => store.user.token;
